module.exports = __webpack_public_path__ + "media/site_templates/www.localcarpenters.net.au/images/feature_3-3d144db145c7d15170eb33e644e4e999.jpeg";